module.exports = __webpack_public_path__ + "img/dol119.9c680ee1.png";